import { useMedia } from "react-use";

export default function useMediaWithInitialState(mediaQuery: string, defaultState = false): boolean {
  return useMedia(mediaQuery, process.browser ? window.matchMedia(mediaQuery).matches : defaultState);
}
